import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Minneapolis (~430 mi) or Denver (~490 mi) — no Lincoln walk-in",
      "NPIC appointment required before traveling to Minneapolis or Denver",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Minneapolis needed",
      "Ideal for UNL students studying abroad",
      "Perfect for Capitol staff and state government travelers",
      "Great for families in Waverly, Hickman, Seward, and Crete",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Lincoln post offices",
      "Good for planned international trips from Lincoln Airport",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Lancaster County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function LincolnProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Lincoln"
      introText="Lincoln travelers — UNL students preparing for study abroad, Capitol staff attending international trade delegations, Bryan Health medical professionals presenting at overseas conferences, and families flying out of Lincoln Airport (LNK) — have several options for getting a passport fast. Here is how they compare, and why most Nebraska residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Minneapolis or Denver."
      options={options}
      emergencyDescription="Lincoln does not have its own regional passport agency. The closest are Minneapolis (~430 mi, 6.5+ hrs via I-80/I-35) and Denver (~490 mi, 7+ hrs via I-80/I-76). Winter conditions on I-80 — ice storms, whiteouts, and blizzard closures — make both routes dangerous and unpredictable from November through March."
      disclaimerText="*Processing speed depends on eligibility and documentation. Lincoln does not have a regional passport agency — the closest are Minneapolis, MN and Denver, CO. Not all applicants qualify for Regional Agency Processing."
    />
  );
}